// Memory groups: point groups a macro's Group edit steps make and change, kept by the page (one scan's: name -> vertex
// mask) and never written to the scan's log; a Group save step writes one as a saved group. A scan's vertex order
// is fixed once loaded, so the masks hold across reloads of its edits. Their names are apart from the saved groups'
// (an edit to a saved group's name is refused). Masks are never changed in place, so a copy of the map is a snapshot.

export type MemGroups = Map<string, Uint8Array>;

/**
 * One scan's memory groups after a Group edit with its selected points m: add moves them into the group (out of
 * any other memory group, making it if missing), remove takes them out, clear empties it (making it empty if
 * missing). null: nothing changes.
 */
export function memEdit(g: MemGroups, m: Uint8Array, act: 'add' | 'remove' | 'clear', name: string): MemGroups | null {
  const cur = g.get(name);
  if (act === 'clear') return cur && !cur.some(x => x) ? null : new Map(g).set(name, new Uint8Array(m.length));
  if (!m.some(x => x)) return null;
  if (act === 'remove') {
    if (!cur) return null;
    const o = cur.slice();
    let k = 0;
    for (let i = 0; i < o.length; i++) if (o[i] && m[i]) { o[i] = 0; k++; }
    return k ? new Map(g).set(name, o) : null;
  }
  const out = new Map(g);
  // a point is in one group at a time: out of the others, then into this one
  for (const [k, x] of g) {
    if (k === name || !x.some((v, i) => v && m[i])) continue;
    const o = x.slice();
    for (let i = 0; i < o.length; i++) if (m[i]) o[i] = 0;
    out.set(k, o);
  }
  const o = cur ? cur.slice() : new Uint8Array(m.length);
  for (let i = 0; i < o.length; i++) o[i] |= m[i];
  return out.set(name, o);
}

/** Points in one scan's memory group mask. */
export const memCount = (m: Uint8Array) => { let n = 0; for (let i = 0; i < m.length; i++) n += m[i]; return n; };
